import React, { FC } from "react";

import { Paper, PaperProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { BoxShadow } from "./theme";

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: "15px",
  boxShadow: BoxShadow,
  padding: "30px 40px 30px 40px",
}));

/**
 * @see Paper
 */
export const IgPaper: FC<PaperProps> = (props) => {
  const { children, ...rest } = props;
  return (
    <StyledPaper variant={"outlined"} elevation={0} {...rest}>
      {children}
    </StyledPaper>
  );
};
